import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        pointerEvents: "none",
        position: "absolute"
    }
});
export default stylesheet;
